export default __webpack_public_path__ + "static/media/element_spec_94.ec43d14d.webp";